import React from "react";
import { Form } from "react-bootstrap";
import { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";


interface IProps{
    examCertificates: Array<CcAssessmentPathwayEnrollmentCertificate>;
    updateCertificateAttestation: (certificate: CcAssessmentPathwayEnrollmentCertificate) => void;
}

export default function ExamPathwayTerms(props: IProps){
    
    const updateCertificateAttestations = (e: React.ChangeEvent<HTMLInputElement>) => {
        for (var i = 0; i < props.examCertificates.length; i++){
            var updated = props.examCertificates[i];
            updated.ccAssessmentAttestationDate = e.target.checked ? new Date().toString() : null;
            props.updateCertificateAttestation(updated);
        }
    }

    return(
        <React.Fragment>
                <Form.Group>
                    <Form.Text className="font-weight-bold">Recertification Exam Pathway Attestation</Form.Text>
                </Form.Group>
                <Form.Group>
                    <div className="pp-assessment-terms-body">
                        <p>
                            I attest that I have chosen the Recertification Exam pathway to satisfy my Continuing Certification requirement. I agree that 
                            to meet the CC Recertification Exam requirement I must sit for and pass the Recertification Exam once every 10 years. I also
                            agree that to maintain my ABPN certification(s) I must also successfully complete the CC Activity Requirements, pay an annual fee,
                            and maintain a valid and unrestricted medical license. (For an overview see, <a href="https://abpn.org/continuing-certification/">https://abpn.org/continuing-certification/</a>.)
                        </p>
                        <p>
                            I understand and agree that I may switch from the Recertification Exam pathway to the Article-Based Continuing Certification (ABCC) 
                            pathway only up until the end of the sixth year of my 10-year recertification block. 
                            Should I switch to the ABCC pathway, I understand that I will be required to successfully complete all required article exams from 
                            years one through six by the end of the sixth year and all three (3) three-year ABCC blocks by the end of year 9 of my 10-year 
                            recertification block. If I fail to successfully complete three (3) three-year ABCC blocks by the end of year 9, I understand 
                            I will be automatically transferred back to the Recertification Exam pathway and will need to successfully pass the Recertification Exam 
                            by the end of my 10-year recertification block. I understand that requests for changes in the duration of a 3-year block, extensions to 
                            a 3-year block, the number of article exams needing to be successfully completed or any other alteration in the grading or assessment will 
                            be deemed to fundamentally alter the measurement of the skills or knowledge being assessed and will not be granted by the ABPN.
                        </p>
                        <p>
                            I agree the Board is the final judge of my qualification for holding ABPN certification(s) and that I must adhere 
                            to the Board’s applicable policies (see, <a href="https://abpn.org/about/policies">https://abpn.org/about/policies/</a>).
                        </p>
                        <p>
                            I understand that the Board makes academic and scientific judgments in its evaluation of the results of its examinations, 
                            and that situations may occur, even through no fault of mine, that will render my examination results unreliable in the judgement of the Board. 
                            I agree that if the Board determines that the results of my examination are unreliable, the Board may require me to retake that examination.
                        </p>

                        <p>
                            See the General Policies regarding taking a CC/Recertification Examination here: 
                            <a href="https://abpn.org/continuing-certification/continuing-certification-exams/">https://abpn.org/continuing-certification/continuing-certification-exams/</a>
                        </p>
                    </div>
                    <br />
                </Form.Group>
                <Form.Group controlId="examFormAttestationControls">
                    <Form.Check type="checkbox">
                        <Form.Check.Input defaultChecked={false}  type="checkbox" required onChange={updateCertificateAttestations} />
                        <Form.Check.Label><strong>I hereby declare under penalty of perjury that the information given in this application is true and correct to the best of my knowledge and belief. I intend to be legally bound by the foregoing.</strong></Form.Check.Label>
                        <Form.Control.Feedback type="invalid">Please attest to the above before continuing</Form.Control.Feedback>
                    </Form.Check>
                </Form.Group>
            </React.Fragment>
    );
}